// extracted by mini-css-extract-plugin
export default {"container":"module_container__458ng"};